import CheckIcon from '@mui/icons-material/Check'
import { Box, Button, Divider, Stack, Typography } from '@mui/material'
import format from 'date-fns/format'

import { useBookingContext } from '@providers/booking'
import { TGroomArrivalTime } from '@providers/booking/types'
import { i18WithParams as t } from '@shared/locale'
import { hasRequestTime } from 'components-ui/src/shared/location'
import { Types } from 'service-api'
import { TPetOffers } from '../types'
import { getInStayLBC } from './helper'
import { ShowAnyGroomer } from './show_anygroomer'

export const DatesViewer = ({ groomOffer }: { groomOffer: TPetOffers }) => {
  const bookingCtx = useBookingContext()
  const dateSelected = groomOffer.requestDates[0]?.date
  const mustRequestTime = hasRequestTime(getInStayLBC(bookingCtx.state, 'grooming'))
  const timeSelected = groomOffer.requestDates[0]?.arrivalTime?.slotStartTime

  const onRemove = () => {
    if (dateSelected) {
      bookingCtx.dispatch({
        type: 'SET_REQUEST_DATE',
        payload: {
          groupIdx: groomOffer.groupIdx,
          petIdx: groomOffer.pet.petIdx,
        },
      })
    }
  }

  const stackStyles = dateSelected
    ? { alignItems: 'start' }
    : {
        alignItems: 'center',
        justifyContent: 'center',
      }

  const handleRemoveGrooming = () => {
    const { petIdx } = groomOffer.pet
    const { groupIdx } = groomOffer
    const groom = bookingCtx.state.cart.groups[groupIdx].grooms[petIdx]
    if (groom.offers?.length > 0) {
      bookingCtx.dispatch({
        type: 'REMOVE_GROOM_FOR_PET',
        payload: { groupIdx: groupIdx, petIdx: petIdx },
      })
      onRemove()
    }
  }

  const handleChangeGroomer = () => {
    const { groupIdx } = groomOffer
    const { petIdx } = groomOffer.pet

    bookingCtx.dispatch({
      type: 'SET_GROOM_WIZARD_STATE',
      payload: {
        groupIdx: groupIdx,
        petIdx: petIdx,
        state: 'groomer',
        isDone: false,
        anyGroomer: false,
      },
    })
    bookingCtx.dispatch({
      type: 'SET_REQUEST_DATE',
      payload: {
        groupIdx: groomOffer.groupIdx,
        petIdx: groomOffer.pet.petIdx,
      },
    })
  }

  const onSelectArrivalTime = (groomer: Types.ProviderAdminDto, arrivalTime: TGroomArrivalTime) => {
    const { groupIdx } = groomOffer
    const { petIdx } = groomOffer.pet

    bookingCtx.dispatch({
      type: 'SET_GROOM_ARRIVAL_TIME',
      payload: {
        groupIdx: groupIdx,
        petIdx: petIdx,
        value: arrivalTime,
        state: 'dateSelector',
        isDone: true,
        groomer,
      },
    })
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Stack {...stackStyles} p={2} sx={{ minHeight: '120px' }}>
        {!dateSelected && (
          <Typography sx={{ fontSize: '16px', fontWeight: '600', lineHeight: '21px' }}>
            {t('requestDates.grooms.selectADate')}
          </Typography>
        )}
        {dateSelected && !mustRequestTime && (
          <>
            <Typography variant="body1bold">
              {t('requestDates.grooms.selectedDay', {
                selected: format(dateSelected, 'MMM dd, yyyy'),
              })}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>{t('requestDates.grooms.reviewText')}</Typography>
          </>
        )}
        {dateSelected && mustRequestTime && (
          <Box width="100%">
            <ShowAnyGroomer groomOffer={groomOffer} onSelect={onSelectArrivalTime} dateSelected={dateSelected} />
          </Box>
        )}
      </Stack>
      <Divider />
      <Stack direction="row" justifyContent="space-between" sx={{ minHeight: 42 }} alignItems="center">
        {(dateSelected && !mustRequestTime) || (dateSelected && timeSelected) ? (
          <Stack direction="row" alignItems="center" gap={1}>
            <CheckIcon fontSize="small" />
            <Typography variant="body2bold">
              {t('groomingWizard.selectionComplete', { petName: groomOffer.pet.name })}
            </Typography>
          </Stack>
        ) : (
          <Button size="small" onClick={handleChangeGroomer}>
            {t('requestDates.grooms.changeGroomer')}
          </Button>
        )}
        {dateSelected ? (
          <Button size="small" onClick={onRemove}>
            {t('requestDates.grooms.undoSelection')}
          </Button>
        ) : (
          <Button size="small" onClick={handleRemoveGrooming}>
            {t('requestDates.grooms.removeGroom')}
          </Button>
        )}
      </Stack>
    </Stack>
  )
}
